import React from 'react';
import PropTypes from 'prop-types';
import { createTheme } from '@mui/material/styles';

import { withStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import CustomPaper from '../../common/CustomPaper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    pointerEvents: 'none',
    width: '30%',
    margin: 'auto',
  },
});

class SingleSelect extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, data } = this.props;
    const rawPrefillValue = data?.autoAnswer || data?.answer_data_default || '';
    const preselectedValue = typeof rawPrefillValue === 'object' ? '' : rawPrefillValue;
    // Find the matching option value
    const selectedOption = data.answer_list.find(
      n => n[1] === preselectedValue || n[0] === preselectedValue
    );
    const displayValue = selectedOption ? selectedOption[1] : preselectedValue || '';

    try {
      return (
        <div className={classes.root}>
          <FormControl style={{ width: '70%' }}>
            <Select value={displayValue} displayEmpty>
              <MenuItem value="">
                <em>{displayValue || 'None'}</em>
              </MenuItem>
              {data.answer_list.map((n, i) => {
                return (
                  <MenuItem key={i} value={n[1]}>
                    {n[1]}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
      );
    } catch (e) {
      return <h5>Please specify answers in config</h5>;
    }
  }
}

SingleSelect.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SingleSelect);
